import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { TemplateForm } from '../../../components/forms/TemplateForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function TemplateEditPage() {
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/extra-material-templates/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <TemplateForm defaultValues={data?.data} /> : <Loader />;
}
